import React, { useEffect, useState } from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const BackToTopButton = () => {
  const [backToTop, setBackToTop] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
        if(window.scrollY > 100){
            setBackToTop(true)
        }else{
            setBackToTop(false)
        }
    })
  }, [])

  const scroll2Top = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
  }

  return (
    <div>
     {
       backToTop && (
         <button style={{
           position: "fixed",
           bottom: "50px",
           right: "10px",
           height: "35px",
           width: "35px",
           padding: ".7em",
           fontSize: "25px",
           borderRadius: "10px",
           border: "none",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           backgroundColor: "#9c54fc",
           color: "#fff"
           }} onClick={scroll2Top}
          >
        <ArrowUpwardIcon />
         </button>)
     }
    
    </div>
  )
}

export default BackToTopButton
